import { useEffect } from 'react';
import { useNotifySpendingThisMonth } from '../../hooks/useNotifySpendingThisMonth';
import { ModalCategoriesList, ModalEditCategory } from '../features/Categories';

const SharedLayout = ({ children }: { children: React.ReactNode }) => {
  const { notifySpendingThisMonth } = useNotifySpendingThisMonth();

  useEffect(() => {
    notifySpendingThisMonth();
  }, [notifySpendingThisMonth]);

  return (
    <>
      {children}
      <ModalCategoriesList />
      <ModalEditCategory />
    </>
  )
}

export default SharedLayout 